<template>
    <div id="app" class="font-sans min-h-screen bg-background antialiased">
        <router-view/>
        <PortalTarget name="spinner"></PortalTarget>
        <PortalTarget name="modal"></PortalTarget>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'App',
    metaInfo: {
        title: process.env.VUE_APP_TITLE,
    },
    computed: {
        ...mapGetters({
            client: 'settings/getClient',
            params: 'settings/get',
        }),
    },
    data() {
        return {
            config: '',
            theme: '',
        }
    },
    created() {
        window.addEventListener('updatePricesEvent', (event) => {
            if (event.detail !== 'undefined') {
                this.$store.dispatch('packs/updatePrices', event.detail)
            }
        })

        this.$once('destroyed', () => {
            // eslint-disable-next-line no-restricted-globals
            removeEventListener('updatePricesEvent')
        })

        if (this.$route.name !== 'Error') {
            this.$store.dispatch('localisation/get', {
                lang: this.params.lang,
                cc: this.params.cc,
                api_key: this.params.api_key,
            })
        }
    },
    async mounted() {
        if (this.$route.name !== 'Error') {
            this.config = await import(`@/resources/${this.client}`)
            this.theme = this.config.tenant_name.toLowerCase()
                .replace(' ', '-')
        }

        await this.identifyDevice()
    },
    methods: {
        /**
         * Identify user's device.
         *
         * @returns {void}
         */
        async identifyDevice() {
            await this.$store.dispatch('device/identifyDevice')
        },
    },
}
</script>

<style>
    html, body {
        @apply bg-background
    }
</style>
